import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { Box } from '@mui/material'
import React from 'react'

interface SortableChapterProps {
  chapterId: string
  disabled?: boolean
  /** Called with drag-handle props that should be spread onto the chapter header. */
  renderHeader?: (dragHandleProps: Record<string, unknown>) => React.ReactNode
  children: React.ReactNode
}

export default function SortableChapter({ chapterId, disabled, renderHeader, children }: SortableChapterProps) {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: chapterId,
    disabled,
  })

  const style: React.CSSProperties = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.3 : 1,
  }

  const dragHandleProps = disabled ? {} : { ...attributes, ...listeners }

  return (
    <Box
      ref={setNodeRef}
      style={style}
      sx={{
        flex: { xs: '1 1 100%', md: '1 1 280px' },
        maxWidth: { xs: '100%', md: '500px' },
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 2,
        p: 1,
        display: 'flex',
        flexDirection: 'column',
        gap: 0.5,
      }}
    >
      {renderHeader?.(dragHandleProps)}
      {children}
    </Box>
  )
}
